import { useEffect } from "react";

export default function useVideoPostMessages({ videoActions, contentId }) {
  useEffect(() => {
    if (!process.browser) return;

    const cb = (event) => {
      if (!event?.data?.actionName) return;

      // Если в сообщении указан contentId, проверяем что он соответствует текущему плееру
      if (event.data.contentId || event.data.videoId) {
        const messageContentId = event.data.contentId || event.data.videoId;
        if (messageContentId !== contentId) {
          return; // Сообщение не для этого плеера
        }
      }

      switch (event.data.actionName) {
        case "play":
          videoActions.play();
          break;
        case "pause":
          videoActions.pause();
          break;
        case "mute":
          videoActions.mute();
          break;
        case "unmute":
          videoActions.unmute();
          break;
        case "restart":
          videoActions.navigate(0);
          videoActions.play();
          break;
        default:
          break;
      }
    };

    window.addEventListener("message", cb);

    return () => {
      window.removeEventListener("message", cb);
    };
  }, [contentId, videoActions]);
}
